import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ApiOrderRepository } from './infrastructure/api/api-order.repository';
import {
    OrdersTypeLayoutComponent,
} from './layouts/orders-type-layout/orders-type-layout.component';
import { OrderTypeEnum } from './models/orders-type.model';
import { UpdateOrderShippingComponent } from './ui/containers/update-order-shipping/update-order-shipping.component';
import { orderResolver } from './ui/guards/update-order-shipping.resolver';
import { ORDER_REPOSITORY } from './ui/tokens/update-order-shipping.tokens';

import { HttpRequestsService } from '@core/services/http-requests/http-requests.service';
import { AuthGuard } from '@shared/user/guards/auth.guard';

const routes: Routes = [
    {
        path: 'online',
        component: OrdersTypeLayoutComponent,
        data: {
            type: OrderTypeEnum.ONLINE,
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'online/:id/update-shipping',
        component: UpdateOrderShippingComponent,
        resolve: { order: orderResolver },
        providers: [
            {
                provide: ORDER_REPOSITORY,
                useFactory: (http, httpRequestsSrv) => new ApiOrderRepository(http, httpRequestsSrv),
                deps: [HttpClient, HttpRequestsService],
            },
        ],
        canActivate: [AuthGuard],
    },
    {
        path: 'online/:id',
        component: OrdersTypeLayoutComponent,
        data: {
            type: OrderTypeEnum.ONLINE,
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'store',
        component: OrdersTypeLayoutComponent,
        data: {
            type: OrderTypeEnum.STORE,
        },
        canActivate: [AuthGuard],
    },
    {
        path: '**',
        redirectTo: 'online',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class OrdersTypeRoutingModule { }
